export { getRunningQuestion, RunningAnswer } from './RunningFaq';
